import { styled } from '@mui/material/styles';
import { Snackbar } from '@mui/material';

/* Toast appears at BOTTOM CENTER of the viewport. */
export const SWSnackbar = styled(Snackbar)(() => ({
  '& .MuiSnackbarContent-root': {
    backgroundColor: '#0F333E',
    color: 'white',
    boxShadow: '0 4px 24px rgba(0,0,0,0.4)',
    borderRadius: 12,
    minWidth: 320,
    padding: '12px 16px',
    fontSize: '1rem',
    fontWeight: 600,
  },
}));
